module.exports = __webpack_public_path__ + "img/image6.8cc1f930.png";